import { useLocation } from "react-router-dom";
import { usePageHeaderConfig } from "../../contexts/HeaderContext";
import "./styles/AppHeader.css";
import { getPageMetadata } from "./PageMetaData";

export function AppHeader() {
  const location = useLocation();
  const override = usePageHeaderConfig();
  const defaultMeta = getPageMetadata(location.pathname, location.search);

  // Override wins, falls back to central metadata
  const title = override.title ?? defaultMeta.title;
  const subtitle = override.subtitle ?? defaultMeta.subtitle;
  const actions = override.actions;

  return (
    <header className="cp-header" aria-label="Page header">
      {(title || actions) && (
        <div className="cp-header__row cp-header__row--page">
          <div className="cp-header__page-info">
            {title && <h1 className="cp-header__page-title">{title}</h1>}
            {subtitle && <p className="cp-header__page-subtitle">{subtitle}</p>}
          </div>
          {actions && <div className="cp-header__page-actions">{actions}</div>}
        </div>
      )}
    </header>
  );
}
